import services from "@/services"; // pastikan path ini benar
import axios from "axios";
import CryptoJS from "crypto-js";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";

const secretKey = "rahasiaKoperasiAKR-Microfinance";

export const useMainStore = defineStore("main", () => {
  // STATE
  const token = ref(localStorage.getItem("token") || null);
  const user = ref(null);
  const hasStartedWelcome = ref(
    localStorage.getItem("hasStartedWelcome") === "true"
  );
  const isLoading = ref(false);
  const selectedTransaksi = ref(null);
  const profile = ref({});
  const isLoadingProfile = ref(true);
  const snackbarMessage = ref("");
  const snackbarColor = ref("error");

  // WATCH: Auto-fetch profile saat user berubah
  watch(
    user,
    async (val) => {
      if (val?.username && val?.type) {
        isLoadingProfile.value = true;
        try {
          const payload = new FormData();
          payload.append("type", val.type);
          payload.append("username", val.username);
          const response = await services.infoProfile(payload);
          const res = response.data;
          if (res.status === true) {
            profile.value = res.data;
          } else {
            console.warn("❌ Gagal ambil profil:", res.msg);
          }
        } catch (error) {
          console.error("🚨 Error ambil profil:", error);
        } finally {
          isLoadingProfile.value = false;
        }
      }
    },
    { immediate: true }
  );

  // GETTERS
  const isLoggedIn = computed(() => !!user.value);
  const isUserType2 = computed(() => user.value?.type === 2);
  const isUserType3 = computed(() => user.value?.type === 3);

  // ACTIONS
  function checkWelcomeStatus() {
    if (localStorage.getItem("hasStartedWelcome") === null) {
      localStorage.setItem("hasStartedWelcome", "false");
    }
    hasStartedWelcome.value =
      localStorage.getItem("hasStartedWelcome") === "true";
  }

  function setProfile(newProfile) {
    profile.value = { ...newProfile };
  }

  function startWelcome() {
    hasStartedWelcome.value = true;
    localStorage.setItem("hasStartedWelcome", "true");
  }

  function startLoading() {
    isLoading.value = true;
  }

  function stopLoading() {
    isLoading.value = false;
  }

  function login(userData) {
    const tok = userData.Token;
    token.value = tok;
    localStorage.setItem("token", tok);
    axios.defaults.headers.common["Token"] = tok;

    const u = {
      id: userData.id,
      name: userData.name,
      username: userData.username,
      email: userData.email,
      type: userData.type,
    };
    const userString = JSON.stringify(u);
    const encrypted = CryptoJS.AES.encrypt(userString, secretKey).toString();
    localStorage.setItem("usrcrypted", encrypted);

    user.value = u;
  }

  async function loadFromStorage() {
    const tok = localStorage.getItem("token");
    if (tok) {
      token.value = tok;
      axios.defaults.headers.common["Token"] = tok;
    }

    const encrypted = localStorage.getItem("usrcrypted");
    if (encrypted) {
      try {
        const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        user.value = JSON.parse(decrypted);

        // Tambahkan: fetch profile secara manual
        await fetchProfile();
      } catch (e) {
        logout();
      }
    }
  }

  function logout() {
    token.value = null;
    user.value = null;
    localStorage.removeItem("token");
    localStorage.removeItem("usrcrypted");
    delete axios.defaults.headers.common["Token"];
  }

  function showSnackbar(msg, color = "error") {
    snackbarMessage.value = msg;
    snackbarColor.value = color;
    setTimeout(() => {
      snackbarMessage.value = "";
      snackbarColor.value = "error";
    }, 3000);
  }

  function setSelectedTransaksi(transaksi) {
    selectedTransaksi.value = transaksi;
  }

  function clearSelectedTransaksi() {
    selectedTransaksi.value = null;
  }

  async function fetchProfile() {
    if (user.value?.username && user.value?.type) {
      try {
        const payload = new FormData();
        payload.append("type", user.value.type);
        payload.append("username", user.value.username);
        const response = await services.infoProfile(payload);
        const res = response.data;
        if (res.status === true) {
          profile.value = res.data;
        }
      } catch (e) {
        console.error("🔁 Gagal refresh profil:", e);
      }
    }
  }

  return {
    // state
    token,
    user,
    hasStartedWelcome,
    isLoading,
    selectedTransaksi,
    profile,
    isLoadingProfile,

    // getter
    isLoggedIn,
    isUserType2,
    isUserType3,

    // action
    checkWelcomeStatus,
    startWelcome,
    startLoading,
    stopLoading,
    login,
    logout,
    loadFromStorage,
    setSelectedTransaksi,
    clearSelectedTransaksi,
    showSnackbar,

    // opsional
    fetchProfile,
    setProfile,
  };
});
